<template>
  <a-modal
    title="同步短剧"
    centered
    :width="640"
    :mask-closable="false"
    :visible="showSyncForm"
    :confirmLoading="loading"
    @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      >
        <a-spin :spinning="loading">
          <a-form-model-item label="平台" prop="platform_id" help="目前只能同步常读和点众的短剧">
            <a-select placeholder="请选择"  v-model="model.platform_id">
              <template>
                <a-select-option :value="platform.id" v-for="platform in platforms" :key="platform.id">
                  {{ platform.name }}
                </a-select-option>
              </template>
            </a-select>
          </a-form-model-item>
        </a-spin>
      </a-form-model>

    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'Sync';
</style>

<script>
import Sync from './Sync'
export default Sync
</script>
